import { Sparkles, TrendingUp, Star } from 'lucide-react';
import { Badge } from './ui/badge';
import { ImageWithFallback } from './figma/ImageWithFallback';

interface ProfileSidebarSectionsProps {
  suggestedProfiles: any[];
  featuredProfiles: any[];
  onViewProfile?: (profile: any) => void;
}

export function ProfileSidebarSections({ 
  suggestedProfiles, 
  featuredProfiles, 
  onViewProfile 
}: ProfileSidebarSectionsProps) {
  return (
    <>


      {/* Featured Profiles */}
      {featuredProfiles.length > 0 && (
        <div className="bg-gradient-to-br from-purple-50 to-pink-50 rounded-xl p-4 border border-purple-200">
          <div className="flex items-center gap-2 mb-4">
            <Sparkles className="h-5 w-5 text-purple-600" />
            <h3 className="font-bold text-gray-900">Featured Profiles</h3>
            <Badge className="bg-purple-100 text-purple-700 border-purple-200 text-xs">
              Premium
            </Badge>
          </div>
          <div className="space-y-3">
            {featuredProfiles.map((profile) => {
              const firstName = profile.firstName || 
                              profile.userId?.firstName || 
                              profile.basicInfo?.firstName || 
                              profile.name?.split(' ')[0] || 
                              'User';
              const lastName = profile.lastName || 
                             profile.userId?.lastName || 
                             profile.basicInfo?.lastName || 
                             profile.name?.split(' ')[1] || 
                             '';
              
              const showFullName = profile.userId?.preferences?.showFullName !== false;
              const displayName = showFullName 
                ? `${firstName} ${lastName || ''}`.trim()
                : `${firstName} ${lastName ? lastName.charAt(0) + '.' : ''}`.trim();
              
              return (
                <div 
                  key={profile._id}
                  onClick={() => onViewProfile?.(profile)}
                  className="bg-white rounded-lg p-3 border border-purple-100 hover:shadow-md transition-all cursor-pointer group"
                >
                  <div className="flex gap-3">
                    <div className="relative">
                      <div className="w-14 h-14 rounded-full overflow-hidden">
                        <ImageWithFallback
                          src={profile.photos?.[0]?.url || profile.profilePhoto || `https://ui-avatars.com/api/?name=${firstName}`}
                          alt={firstName}
                          className="w-full h-full object-cover"
                        />
                      </div>
                      <div className="absolute -top-1 -right-1 w-5 h-5 bg-yellow-400 rounded-full flex items-center justify-center">
                        <Star className="h-3 w-3 text-white fill-white" />
                      </div>
                    </div>
                    <div className="flex-1 min-w-0">
                      <h4 className="font-semibold text-sm text-gray-900 truncate group-hover:text-purple-600 transition-colors">
                        {displayName}
                      </h4>
                      <p className="text-xs text-gray-600">
                        {profile.age || profile.basicInfo?.age || 26} yrs, {profile.height || profile.basicInfo?.height || "5'5\""}
                      </p>
                      <p className="text-xs text-gray-500 truncate">
                        {profile.occupation || profile.career?.occupation || profile.basicInfo?.occupation || 'Professional'}
                      </p>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      )}
    </>
  );
}
